import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMap: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="map, paper"><path d="M15.25 6.5L8.75 4.5L2.75 6.5V19.5L8.75 17.5M15.25 6.5L21.25 4.5V17.5L15.25 19.5L8.75 17.5M15.25 6.5V19M8.75 17.5V5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconMap;
